import { css } from '@emotion/react';
import styled from '@emotion/styled';
import GemImageBase from 'src/components/GemImage';
import Image from 'src/components/Image';
const imageStyles = ({
  theme
}: {
  theme: Theme;
}) => css`
  width: 36px;
  height: 36px;

  ${theme.isRtl ? 'margin-left' : 'margin-right'}: 10px;
`;
export const IabImage = styled(Image)`
  ${imageStyles}
`;
export const GemImage = styled(GemImageBase)`
  ${imageStyles}
`;
interface Props {
  className?: string;
}
export default function PurchasableProductIcon({
  className
}: Props) {
  return <GemImage className={className} data-sentry-element="GemImage" data-sentry-component="PurchasableProductIcon" data-sentry-source-file="ProductIcon.tsx" />;
}